import React, {useState, useEffect, useMemo, useRef} from 'react';
import {DhcdContact} from './DhcdContact';
import {DhcdControls} from './DhcdControls';
import {DhcdList} from './DhcdList';
import {DhcdPagination} from './DhcdPagination';
import {DhcdSubmenu} from './DhcdSubmenu';
import ShareholderNewsService from '@services/shareholder-relationship-news.service';

export default function ShareholderDetails({
    items: propItems = [],
    categories = [],
    perPageOptions = [5, 10, 20],
    initialPerPage = 5,
    contact = {},
    locale,
    id = 0,
    years = [2026, 2025, 2024, 2023, 2022, 2021, 2020, 2019], // danh sách năm
}) {
    const capitalizeFirstLetter = str => str.charAt(0).toUpperCase() + str.slice(1);
    const isFirstLoad = useRef(true);
    const tabs = useMemo(() => {
        return categories.map(cat => ({
            key: cat.category_id,
            label: capitalizeFirstLetter(cat.category_name.toLocaleLowerCase()),
            categoryId: cat.category_id,
            image: cat.image_url,
        }));
    }, [categories]);

    const [activeTab, setActiveTab] = useState(id);
    const [items, setItems] = useState(propItems);
    const [titleCategory, setTitle] = useState(() => {
        const activeTabObj = tabs.find(t => Number(t.key) === Number(id));
        return activeTabObj?.label || (tabs[0]?.label ?? '');
    });
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(initialPerPage);
    const [year, setYear] = useState(''); // '' = tất cả năm
    const [totalItems, setTotalItems] = useState(0);

    console.log(items);

    useEffect(() => {
        if (items && items.length > 0) {
            setTotalItems(items[0].totalItemsByCategory);
        } else {
            setTotalItems(0);
        }
    }, [items]);

    const totalPages = Math.max(1, Math.ceil(totalItems / perPage));
    const start = (page - 1) * perPage;
    const visible = items.slice(0, perPage);

    const goto = p => {
        setPage(Math.max(1, Math.min(totalPages, p)));
    };

    useEffect(() => {
        const fetchItems = async () => {
            // ✅ LẦN ĐẦU
            if (isFirstLoad.current) {
                isFirstLoad.current = false;

                if (propItems.length > 0) {
                    setItems(propItems);
                    return; // ❌ không gọi API
                }
                // nếu không có propItems → rơi xuống gọi API
            }
            console.log(activeTab);
            // ✅ CÁC LẦN SAU
            try {
                const _shareholderNewsService = new ShareholderNewsService();

                const data = await _shareholderNewsService.getNewsByCategory({
                    locale: locale,
                    page: Number(page),
                    page_size: Number(perPage),
                    id: Number(activeTab),
                    year: Number(year) || undefined,
                });
                console.log('HUNG');
                console.log(data);
                const items = (data || []).map(item => ({
                    id: item.news_id,
                    title: item.title,
                    date: item.created_date,
                    image: item.image_url,
                    file: item.file_url,
                    link: item.link,
                    description: item.short_description,
                    categoryId: item.category_id,
                    totalItemsByCategory: item.total_items_by_category,
                }));
                setItems(items || []);
                const activeTabObj = tabs.find(t => Number(t.key) === Number(activeTab));
                setTitle(activeTabObj?.label || (tabs[0]?.label ?? ''));
            } catch (err) {
                console.error('Error fetching items:', err);
            }
        };

        fetchItems();
    }, [page, perPage, activeTab, year, locale]);

    return (
        <>
            <DhcdSubmenu
                tabs={tabs}
                active={activeTab}
                onChange={tabKey => {
                    setActiveTab(tabKey);
                    const tab = tabs.find(t => Number(t.key) === tabKey);
                    console.log(tabKey);
                    setTitle(tab?.label ?? '');
                    setPage(1);
                }}
            />

            <div className="shareholder-container">
                <div className="company">
                    <section className="dhcd-section">
                        <div className="dhcd-container">
                            <h1 className="dhcd-title">{titleCategory}</h1>

                            <DhcdControls
                                start={start}
                                total={totalItems}
                                visibleCount={visible.length}
                                perPage={perPage}
                                setPerPage={value => {
                                    setPerPage(value);
                                    setPage(1);
                                }}
                                setPage={setPage}
                                perPageOptions={perPageOptions}
                                years={years}
                                year={year}
                                setYear={y => {
                                    setYear(y);
                                    setPage(1); // reset page khi đổi năm
                                }}
                            />

                            <DhcdList items={visible} />
                            <DhcdPagination page={page} totalPages={totalPages} goto={goto} />
                            <DhcdContact contact={contact} />
                        </div>
                    </section>
                </div>
                <div className="space"></div>
            </div>
        </>
    );
}
